import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';

import DistAPI from '../../../api/DistributionAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import ApiUiController from '../../../controller/ApiUiController';
import FieldController from '../../../controller/FieldController';
import ConditionView from './ConditionView';
import Util from '../../../util/Util';

class LeadDistributionPreview extends React.Component {

  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.state = { inApiCall: true };
    const model = reactLocalStorage.getObject(Const.Model);
    this.model = model.lead;

    this.fields = FieldController.getFilterFields(this.model.fields);
    this.users = model.user.options;

    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.indexOf('/preview'));
    this.dist = { name: '', priority: 0, condition_option: 0, condition: [], assign_to: [] };
  }

  componentDidMount() { DistAPI.get(this.id, this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = dist => {
    const assign_to = this.users.filter(usr =>
      dist.assign_to.includes(Const.Opt + usr.value + Const.Opt));
    const conditions = JSON.parse(dist.conditions);
    this.dist = {
      name: dist.name, priority: dist.priority, condition_option: dist.condition_option,
      conditions, assign_to
    };
    this.setState({ inApiCall: false });
  };

  render() {
    const assign_to = this.dist.assign_to.map(tmp => tmp.label).join(`${Const.Comn} `);
    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <div className="row mb-6">
              <div className="col-md-6 pb-3"><h3>{this.dist.name}</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead><tr><th>Priority</th><th>Conditional Option</th></tr></thead>
                  <tbody>
                    <tr>
                      <td>{this.dist.priority}</td>
                      <td>{this.dist.condition_option === Const.True ? 'AND' : 'OR'}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              <div className="formhead col-md-12"><h4>Condition</h4></div>
              <ConditionView model={this.model} fields={this.fields} value={this.dist.conditions} />

              <div className="col-md-6 pb-3"><h3>Assign To</h3></div>
              <div className="col-md-12">
                <Table className="table-th-color" bordered>
                  <thead><tr><td>{assign_to}</td></tr></thead>
                </Table>
              </div>
            </div>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(LeadDistributionPreview);
